// extracted by mini-css-extract-plugin
export var logo = "_l7-2";
export var logoWrapper = "_l7-1";
export var strip = "_l7-0";